import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const firebaseCongfig = {
    storageBucket: "gs://hbc-teyran-licences.appspot.com",
};

const app = initializeApp(firebaseCongfig);

const storage = getStorage(app);

export const uploadToFirebase = async (file: File, path: string) => {
    try {
        let fileRef = ref(storage, path + "/" + file.name);

        const fileUrl = await uploadBytes(fileRef, file).then(async () => {
            return await getDownloadURL(fileRef).then((url) => url);
        });

        console.log(fileUrl);

        return fileUrl;
    } catch (error) {
        console.log(error);
        return "";
    }
}